var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8380_20957"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 10,
    id: "svg_1",
    width: 10
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8380_20957)",
    id: "svg_2",
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.33,
    cy: 4.34,
    fill: "#231E1E",
    id: "svg_6",
    r: 3.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.03,6.25c-0.66,-0.08 -1.06,0.54 -0.83,0.83l1.75,1.74c0.23,0.23 0.61,0.23 0.84,0c0.22,-0.22 0.22,-0.59 0,-0.83l-1.76,-1.74z",
    fill: "#231E1E",
    id: "svg_5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.32,
    cy: 4.34,
    fill: "#009A7E",
    id: "svg_3",
    r: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarSearchIcon);
export default __webpack_public_path__ + "static/media/SideBarSearchIcon.0e9cc03de21cf6066a6bfd0859e32ca6.svg";
export { ForwardRef as ReactComponent };